import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";
import "core-js/stable";
import "regenerator-runtime/runtime";

ReactDOM.render(<App />, document.getElementById("root"));
